import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "h-8 flex my-3 justify-center" }
const _hoisted_2 = { class: "w-56 text-xs text-gray-700 text-left my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.lotteryRabelVisibility)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: "exchangeStatus",
          class: _normalizeClass(["w-16 text-white text-xs flex justify-center items-center rounded-sm mr-1", {
        issuable: _ctx.exchangeResult.gift_issuable,
        'no-issuable': !_ctx.exchangeResult.gift_issuable,
      }])
        }, _toDisplayString(_ctx.resultLabel), 3))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.exchangingRequestDateTitle) + "：" + _toDisplayString(_ctx.exchangeResult.created_at), 1)
  ]))
}